import { useQuery } from '@tanstack/react-query';

import { PublicApiBuild } from '@/models/Build';
import { publicApi } from '@/utils/api';

type UseArchivedBuildsParams = {
  appSlug: string;
  beforeTimestamp: number;
  afterTimestamp: number;
  limit: number;
};

type ArchivedBuildsResponse = {
  data: PublicApiBuild[];
  paging: {
    next?: string;
    pageItemLimit: number;
    totalItemCount: number;
  };
};

const useArchivedBuilds = ({ appSlug, beforeTimestamp, afterTimestamp, limit }: UseArchivedBuildsParams) => {
  const query = useQuery({
    queryKey: ['archivedBuilds', appSlug, beforeTimestamp, afterTimestamp, limit],

    queryFn: async () => {
      const { data } = await publicApi.get<ArchivedBuildsResponse>(
        `/v0.1/apps/${appSlug}/archived-builds?before=${beforeTimestamp}&after=${afterTimestamp}&limit=${limit}`,
      );

      return {
        archivedBuilds: data.data,
      };
    },

    retry: false,
    staleTime: Infinity,
  });

  return {
    isLoading: query.isLoading,
    isError: query.isError,
    archivedBuilds: query.data?.archivedBuilds,
  };
};

export default useArchivedBuilds;
